import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { getDraftInfoForHeaderBanner } from '../../drafts/utils/DraftUtils';
import { WorkbookSpace, WorkbookSpaceDispatchProps, WorkbookSpaceStateProps } from './WorkbookSpace';


const mapStateToProps: MapStateToProps<WorkbookSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  contentCounts: selectContentCounts<'workbook'>(state, 'workbook'),
  contentCountsUptoDate: selectContentCountsUpToDate(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  draft: state.drafts?.drafts && getDraftInfoForHeaderBanner(state.drafts),
});

const mapDispatchToProps: MapDispatchToProps<WorkbookSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedWorkbookSpace = connect(mapStateToProps, mapDispatchToProps)(WorkbookSpace);
